// axios请求方法（get、post等）封装
export const get = (axios, url = '', params = {}, useCache = {}, headers = {}) => {
  // let for(headers)
  // if(headers) axios.defaults.headers
  if (Object.keys(headers).length > 0) {
    // for (const key in headers) {
    //   console.log(key + ':' + headers[key])
    //   // axios.defaults
    // }
    // axios.create({ headers })
    Object.assign(axios.defaults.headers, headers)
    // console.log(axios.create().interceptors.request, 123)
    url = url + '?'
    for (const key in params) {
      if (params[key]) {
        url += `${key}=${params[key]}&`
      }
    }
    return axios({ url, headers, useCache })
  }
  // console.log(useCache, 123)
  return axios.get(url, { params, headers, useCache })
}

export const post = (axios, url = '', data = {}, useCache = false, headers = {}) => {
  if (Object.keys(headers).length > 0) {
    axios.defaults.headers = headers
  } else {
    axios.defaults.headers = {}
  }
  return axios.post(url, data)
}

export const postv3 = (axios, url = '', data = {}, useCache = {}, _headers = {}) => {
  // console.log(_headers, 3334, data, 222, useCache)
  return axios.post(url, data, {
    headers: _headers,
    useCache
  })
}
